import styled from "styled-components";

export const Box = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
  padding: 0 1px;

  @media print {
    height: auto;
    overflow: visible;
  }
`;

export const BoxClinical = styled.div`
  display: flex;
  flex-direction: column;
  background-color: white;
  color: #343536;
  padding: 20px;
  gap: 20px;
  h5 {
    font-weight: bold;
  }

  p {
    font-weight: 500;
    padding: 5px 0;
  }
`;

export const Section = styled.div``;

export const BudgetSection = styled.div`
  padding: 20px;
  background: linear-gradient(135deg, #f0fdf4 0%, #dcfce7 100%);
  border-radius: 12px;
  border: 2px dashed #10b981;
  text-align: center;
  
  h6 {
    color: #065f46;
  }
`;

export const BoxSave = styled.div`
  padding: 10px;
  background-color: #007ded;
  width: 80px;
  color: white;
  text-align: center;
  border-radius: 5px;
  cursor: pointer;

  @media print {
    display: none;
  }
`;

export const BtnFixed = styled.div`
  display: flex;
  flex-direction: row;
  gap: 25px;
  padding: 15px 0;
`;

export const BoxClinicalSignature = styled.div`
  display: flex;
  flex-direction: column;
  background-color: white;
  color: #343536;
  padding: 20px;
  gap: 20px;

  .boxSignature {
    border: 1px solid #c5c5c5;
    width: 100%;

    .sigCanvas {
      width: 100%;
    }
  }
  h5 {
    font-weight: bold;
    padding: 0;
  }

  p {
    font-weight: 500;
    padding: 5px 0;
  }
`;
